import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
class PermissionService {
  constructor(
    // private authService: AuthService,
    private router: Router) { } // Asegúrate de inyectar tu servicio de autenticación y el router

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredPermission = route.data['requiredPermission'] as string;
    // const hasPermission = this.authService.userHasPermission(requiredPermission); // Asegúrate de implementar este método en tu servicio de autenticación

    // if (!hasPermission) {
    if (!true) {
      this.router.navigate(['/home']); // Redirige al usuario a una ruta de error si no tiene el permiso requerido
      return false;
    }

    return true;
  }
 
}
 

export const PermissionUserGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const permissionService = inject(PermissionService);
  return permissionService.canActivate(next, state);
}

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => PermissionUserGuard(route, state);